import React, { useMemo } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { useDescriptionTracking } from '#src/app/pages/petitionDetails/shared/hooks';
import { Html } from '#src/app/shared/components/html';
import { useRichMediaTransformers } from '#src/app/shared/hooks/richMedia';

import { descriptionAdjacentAnchorsAccessibilityTransformer } from '../../utils/descriptionAdjacentAnchorsAccessibility';

export const DescriptionContent: React.FC = () => {
	const { trackClickLink } = useDescriptionTracking();

	const {
		data: {
			petition: { description },
		},
	} = usePetitionDetailsPageData();

	const { decodeRichMediaTransformer } = useRichMediaTransformers();
	const htmlTransformers = useMemo(
		() => [decodeRichMediaTransformer, descriptionAdjacentAnchorsAccessibilityTransformer],
		[decodeRichMediaTransformer],
	);

	return (
		<div data-qa="description-content" data-testid="description-html-content">
			<Html
				size="default"
				variant="body"
				breakWord
				html={description}
				className="leading-[28px] [&_iframe]:aspect-video [&_iframe]:h-auto [&_iframe]:w-full"
				transformers={htmlTransformers}
				onClickLink={trackClickLink}
				expressive
			/>
		</div>
	);
};
